<template>
  <div
    v-if="!rail"
    class="px-2 pb-2 text-body-small font-weight-medium text-center"
    :style="settingsStore.isChristmasDecorationEnabled ? `background-image: url('/holidays/snow.png')` : undefined"
    style="background-position: center; background-size: cover"
  >
    <v-divider />

    <div class="mt-2 d-flex flex-column ga-1">
      <div>
        <a class="text-white side-menu-link" href="tel:+31850601404">085-0601404</a>
      </div>
      <div>
        <a class="text-white side-menu-link" href="mailto:support@sambeheer.nl">support@sambeheer.nl</a>
      </div>
    </div>

    <v-divider class="my-2" />

    <div class="d-flex flex-column ga-1">
      <div
        v-if="frontendVersion"
        class="opacity-60"
        style="font-size: 9px"
        :title="$d(new Date(runtimeConfig.public.JOB_TIMESTAMP), 'long')"
      >
        <span class="d-inline-block ellipsis" style="max-width: 75%">FRONT: {{ frontendVersion }}{{ environmentTier }}</span>
      </div>
      <div v-if="backendVersion && backendDate" class="opacity-60" style="font-size: 9px" :title="$d(new Date(backendDate), 'long')">
        <span class="d-inline-block ellipsis" style="max-width: 75%">API: {{ backendVersion }}</span>
      </div>
      <div>© SAM B.V. {{ new Date().getFullYear() }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface VersionInfo {
  version: string
  tier: string
  date: string
}

defineProps<{ rail?: boolean }>()

const runtimeConfig = useRuntimeConfig()
const settingsStore = useSettingsStore()

const backendVersion = ref("")
const backendDate = ref("")
const ENVIRONMENT_TIER = runtimeConfig.public.ENVIRONMENT_TIER

const { data: frontendVersion } = useLazyAsyncData("frontend-version", async () =>
  fetch("/version", { cache: "no-store" }).then((res) => res.text()),
)

const environmentTier = computed(() => (ENVIRONMENT_TIER !== "production" ? `-${ENVIRONMENT_TIER}` : ""))

onMounted(async () => {
  try {
    const { data: backendVersionData } = await useSamApi<VersionInfo>("/version")
    backendVersion.value =
      backendVersionData.tier === "production" ? backendVersionData.version : `${backendVersionData.version}-${backendVersionData.tier}`
    backendDate.value = backendVersionData.date
  } catch (error) {
    console.error("Failed to fetch backend version", error)
  }
})
</script>

<style scoped>
.side-menu-link {
  display: inline-block;
  text-decoration: none;
}

.side-menu-link:hover {
  text-decoration: underline;
}
</style>
